import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrCurrency = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.currency
)
